// extracted by mini-css-extract-plugin
module.exports = {"twoColumnLayout":"InspectionDocuments_twoColumnLayout__u-wEw","column":"InspectionDocuments_column__1oHr9"};